module.exports = __webpack_public_path__ + "img/gallery-nft-01.fbc5e70d.png";